
        <span
            [ngClass]="[
                'letter-avatar',
                'letter-avatar-' + type + (inverse ? '-inverse' : '')
            ]"
            #letterDisplay
            [ngStyle]="dimensions"
        >
            <ng-content></ng-content>
        </span>
    